"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pushbutton_1 = __importDefault(require("../../style/shared/pushbutton"));
exports.default = theme => {
    const sharedStyles = pushbutton_1.default(theme);
    return {
        root: {
            ...sharedStyles.root,
            textDecoration: 'none',
            '&[data-is-disabled="true"]': {
                opacity: 0.6
            }
        },
        prefix: {
            ...sharedStyles.prefix
        },
        suffix: {
            ...sharedStyles.suffix
        },
        text: {
            ...sharedStyles.text
        }
    };
};
//# sourceMappingURL=pushbuttonHref.style.js.map